import { render, staticRenderFns } from "./NumberChart.vue?vue&type=template&id=5586f6dd&"
import script from "./NumberChart.vue?vue&type=script&lang=js&"
export * from "./NumberChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports